import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MantenedorCargasService } from 'src/app/services/mantenedor-cargas/mantenedor-cargas.service';
import { MantenedorUsuariosService } from 'src/app/services/mantenedor-usuarios/mantenedor-usuarios.service';

import {FormControl} from '@angular/forms';
import {Observable,of, Subscription} from 'rxjs';
import {map,tap ,startWith} from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Usuario } from 'src/app/models/usuario/usuario.model';

export interface DialogData
{
    sexo: any
    recarga: boolean
    tipoCarga: any
    usuarios: any
    estadoCivil: any
    idEjecutivo: any
}
declare const Rut: any;
@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/mantenedor-cargas/crear-carga.component.html',
    styleUrls: ['../../pages/mantenedor-cargas/mantenedor-cargas.component.css']
})
export class DialogCreaCarga
{
    termino: string  = '';

    usuarios: any = { nombres:null, apellidoPaterno: null, apellidoMaterno: null, rut: null, correo: null,
        tipoAfiliado: null, estadoAfiliado: 'Afiliado', sexo: null, estadoCivil: null,
        fechaIngreso: null, fechaNacimiento: null, fonoFijo: null, fonoMovil: null, prevision: null ,
        direccion: { descripcion: null, comuna: null, region: null, numero: null, sistemaSalud: null ,
        descripcionAdicional: null }, datosLaborales: { tipoUnidad: null, unidad: null,
        calidadJuridica: null, estamento: null, direccion: { descripcion: null, comuna: null,
        region: null, numero: null,idEjecutivo: null ,descripcionAdicional: null } }, rol: null }


    carga: any = { nombre:null, apellido: null, rut: null, sexo: null, tipoCarga: null, usuarios: null ,
                   fechaIngreso: null, fechaNacimiento: null, fechaDefuncion: null,
                   parentesco: null, fechaExpiracion: null, usuario: null ,estadoCivil:null}

    constructor( public dialogRef: MatDialogRef<DialogCreaCarga>, private dialog: MatDialog,
                 @Inject(MAT_DIALOG_DATA) public data: DialogData,
                 private mantenedorUsuarioService: MantenedorUsuariosService,
                 private mantenedorService: MantenedorCargasService,private http: HttpClient)
    {
        this.data.recarga = false
        this.data.idEjecutivo = localStorage.getItem("idUsuario")
        this.data.sexo = [ { descripcion: 'Hombre', id: '1' }, { descripcion: 'Mujer', id: '2' } ]
    }

    ngOnInit(): void {

        this.loadData()
    }


    buscandor() {
        let vm = this
        this.mantenedorService.traerUsuarioSugerido( this.termino.trim() )
        .subscribe( usuarios => vm.data.usuarios = usuarios );
    }
    opcionSeleccionada( event: MatAutocompleteSelectedEvent ) {

    if(!event.option.value) {
        this.usuarios = undefined;
        return;
    }
    const user = event.option.value;

    }



    loadData()
    {
        let vm = this

        this.mantenedorService.traeEstadoCivil().then( estados => vm.data.estadoCivil = estados )

        this.mantenedorService.traeTipoCarga().then( tipo => vm.data.tipoCarga = tipo )

        this.mantenedorUsuarioService.traeUsuarios().then
            (
                (usuarios: any) => {
                    vm.usuarios = usuarios
                }
            )
            .catch(error => {
                console.log(error)

                vm.openAlertDialog("No hay registros disponibles.", "btn-danger")
            })


    }


    crearCarga(): void
    {
        let fd = new Date(this.carga.fechaDefuncion);
        let fc = new Date(this.carga.fechaIngreso);
        let fe = new Date(this.carga.fechaExpiracion);
        let fn = new Date(this.carga.fechaNacimiento);
        if(this.data.idEjecutivo){
            this.carga.idEjecutivo = this.data.idEjecutivo
        }

        if(fc.getTime() < fe.getTime()){
            if(fd.getTime()==0 || ((fd.getTime()!=0) && fd.getTime() > fn.getTime())){
                if(fn.getTime() <= fc.getTime()){
                    if(fe.getTime() > fn.getTime()){
                        if(Rut( this.carga.rut)){
                            let vm = this
                            let rutTitular= vm.termino.split(',')[1]
                            this.carga.rutTitular = rutTitular.split('-')[0]

                            let fechaNacimiento = this.carga.fechaNacimiento.split('-')[2] + '-' +
                                                this.carga.fechaNacimiento.split('-')[1] + '-' +
                                                this.carga.fechaNacimiento.split('-')[0]

                            let fechaIngreso = this.carga.fechaIngreso.split('-')[2] + '-' +
                                            this.carga.fechaIngreso.split('-')[1] + '-' +
                                            this.carga.fechaIngreso.split('-')[0]

                            let fechaDefuncion=""
                            if(this.carga.fechaDefuncion){
                                fechaDefuncion = this.carga.fechaDefuncion.split('-')[2] + '-' +
                                this.carga.fechaDefuncion.split('-')[1] + '-' +
                                this.carga.fechaDefuncion.split('-')[0]
                            }

                            let fechaExpiracion = this.carga.fechaExpiracion.split('-')[2] + '-' +
                                            this.carga.fechaExpiracion.split('-')[1] + '-' +
                                            this.carga.fechaExpiracion.split('-')[0]

                            this.carga.fechaNacimiento = fechaNacimiento, this.carga.fechaIngreso = fechaIngreso
                            this.carga.fechaDefuncion = fechaDefuncion, this.carga.fechaExpiracion = fechaExpiracion

                            this.mantenedorService.creaCarga(this.carga).then
                            (
                                () =>
                                {
                                    vm.openAlertDialog('La Carga se ha creado exitosamente.', 'btn-success')

                                    vm.data.recarga = true
                                    vm.dialogRef.close()
                                }
                            )
                            .catch(error =>
                            {
                                console.log(error)

                                vm.openAlertDialog('Ha ocurrido un error al crear la Carga', 'btn-danger')
                                vm.dialogRef.close()
                            })
                        }else{
                            this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger')
                        }
                    }else{
                        this.openAlertDialog('La fecha de nacimiento debe ser menor a la fecha de expiración', 'btn-danger')
                    }
                }else{
                    this.openAlertDialog('La fecha de nacimiento debe ser menor a la fecha de ingreso', 'btn-danger')
                }
            }else{
                this.openAlertDialog('La fecha de nacimiento debe ser menor a la fecha de defunción', 'btn-danger')
            }
        }else{
            this.openAlertDialog('La fecha de expiración debe ser mayor a la fecha de ingreso', 'btn-danger')
        }
    }

    onCancelarClick(): void { this.dialogRef.close() }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}
